import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ConditionalWrapper from 'components/application/ConditionalWrapper';
import Tooltip from 'components/application/Tooltip';

export default function Tab({
  activeTab,
  disabled,
  flag,
  icon,
  id,
  label,
  onTabClick,
  tooltipText,
}) {
  const onClick = () => {
    if (!disabled) onTabClick(id);
  };

  const tabClassName = (() => {
    switch (true) {
      case disabled:
        return 'tab--disabled tw-text-grey-300 [&_svg_path]:tw-fill-grey-300';
      case activeTab === id:
        return "tab--active tw-text-blue-400 after:tw-content-[''] after:tw-border-blue-400 [&_svg_path]:tw-fill-blue-400";
      default:
        return "tw-text-grey-500 [&_svg_path]:tw-fill-grey-500 hover:after:tw-content-[''] hover:after:tw-border-blue-400";
    }
  })();

  return (
    <>
      <li
        className={classNames('tab', tabClassName, flag && 'tw-mr-0')}
        onClick={onClick}
      >
        <div className='tab__content-wrapper'>
          <ConditionalWrapper
            condition={disabled && tooltipText}
            wrapper={(children) => (
              <Tooltip placement='top' tooltip={tooltipText} trigger='hover'>
                {children}
              </Tooltip>
            )}
          >
            {icon}
            <span className='tab__text tw-font-medium'>{label}</span>
          </ConditionalWrapper>
        </div>
      </li>
      {flag}
    </>
  );
}

Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  flag: PropTypes.element,
  icon: PropTypes.element,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
};
